import { setCookie } from 'nookies'
import { toast } from 'react-toastify'

import {
	getUser,
	setProfile,
	clear,
	logout,
	getDefaultCookieOptions,
	loginUserByGetToken
} from '../../services/auth'
import { postLikeProfessionalsIds } from '../../services/favorites'
import { saveMatchMakerIds } from '../../services/match-maker'
import { updatePhoto } from '../../services/userService'
import { getSocialThumbByBrowser } from '../../utils/helpers'

import { CLEAR_SCHEDULE } from './consultation'

const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
const BLOCK_LINKS_IN_HEADER = 'BLOCK_LINKS_IN_HEADER'
const LOADING_LOGIN = 'LOADING_LOGIN'
const LOGOUT = 'LOGOUT'
const UPDATE_PROFILE_PHOTO = 'UPDATE_PROFILE_PHOTO'
const UPDATE_PARTNERSHIPS_LIST = 'UPDATE_PARTNERSHIPS_LIST'

const INITIAL_STATE = {
	loading: false,
	error: false,
	user: null,
	blockLinksInHeader: false,
	partnershipsList: []
}

export default function reducer(state = INITIAL_STATE, action) {
	switch (action.type) {
		case LOADING_LOGIN:
			return {
				...state,
				loading: action.payload
			}
		case LOGIN_SUCCESS:
			return {
				...state,
				user: action.payload
			}
		case LOGOUT:
			return {
				loading: false,
				error: false,
				user: undefined
			}
		case UPDATE_PROFILE_PHOTO:
			return {
				...state,
				user: {
					...state.user,
					social_thumb: action.payload.social_thumb
				}
			}
		case BLOCK_LINKS_IN_HEADER:
			return {
				...state,
				blockLinksInHeader: action.payload
			}
		case UPDATE_PARTNERSHIPS_LIST:
			return {
				...state,
				partnershipsList: action.payload
			}
		default:
			return state
	}
}

export const loginPat = (credentials) => (dispatch) => {
	return new Promise((resolve, reject) => {
		dispatch({ type: LOADING_LOGIN, payload: true })
		loginUserByGetToken({
			username: credentials.username,
			password: credentials.password
		})
			.then((loginResponse) => {
				if (loginResponse.ok) {
					localStorage.removeItem('@vittude:match-maker')
					getUser() // chamada do /me e retorna a resposta // depois, substituir por refetchFreshUserMe(), mas vai ter impacto no contexto de loading do redux
						.then(async (userMeResponse) => {
							dispatch({
								type: LOGIN_SUCCESS,
								payload: {
									...userMeResponse.data.content.user,
									social_thumb: getSocialThumbByBrowser(
										userMeResponse.data.content.user
									)
								}
							})
							try {
								const matchmakingId = JSON.parse(
									localStorage.getItem('idMatchmaking')
								)
								if (matchmakingId) {
									await saveMatchMakerIds({
										session_ids: matchmakingId,
										id: userMeResponse.data.content.user.id
									})
									localStorage.removeItem('idMatchmaking')
								}
							} catch (error) {
								console.error('saving match maker ids error', error)
							}
							setCookie(
								null,
								'@vittude:user',
								JSON.stringify({
									contract: userMeResponse.data.content.user.contract,
									id: userMeResponse.data.content.user.id
								}),
								{
									...getDefaultCookieOptions(),
									maxAge: 30 * 24 * 60 * 60
								}
							)
							setProfile({
								...userMeResponse.data.content.user,
								social_thumb: getSocialThumbByBrowser(
									userMeResponse.data.content.user
								)
							})
							try {
								if (localStorage.getItem('likeProfessionals')) {
									const likeProfessionalsIds = JSON.parse(
										localStorage.getItem('likeProfessionals')
									).map((professional) => professional.id)
									await postLikeProfessionalsIds({
										professional_ids: likeProfessionalsIds
									})
									localStorage.removeItem('likeProfessionals')
								}
							} catch (error) {
								console.log(error)
							}

							dispatch({ type: LOADING_LOGIN, payload: false })
							resolve(userMeResponse)
						})
						.catch((err) => {
							clear()
							reject(err?.response?.data?.log_content?.error_code)
						})
				} else {
					clear()
					reject({ status: 401 })
				}
			})
			.catch((error) => {
				const errorData = error.response?.data

				if (
					errorData?.log_content?.error_code !== 'mfa_required' &&
					errorData?.message !== 'sso_required'
				) {
					toast.error('Dados de usuário incorretos.', {
						autoClose: 5000
					})
					clear()
				}

				reject(error)
			})
	})
}

export const loginPsycho = (credentials) => (dispatch) => {
	const { cpf_cnpj, password } = credentials
	const userLoginData = {
		username: cpf_cnpj.replace(new RegExp('[^0-9]', 'g'), ''),
		password
	}
	return new Promise((resolve, reject) => {
		dispatch({ type: LOADING_LOGIN, payload: true })
		loginUserByGetToken({
			username: userLoginData.username,
			password: userLoginData.password
		})
			.then((loginResponse) => {
				if (loginResponse.ok) {
					getUser().then((userMeResponse) => {
						dispatch({
							type: LOGIN_SUCCESS,
							payload: {
								...userMeResponse?.data?.content?.user,
								social_thumb: getSocialThumbByBrowser(
									userMeResponse?.data?.content?.user
								)
							}
						})
						setProfile({
							...userMeResponse.data.content.user,
							social_thumb: getSocialThumbByBrowser(
								userMeResponse?.data?.content?.user
							)
						})
						dispatch({ type: LOADING_LOGIN, payload: false })
						resolve()
					})
				} else {
					clear()
					reject({ status: 401 })
				}
			})
			.catch((err) => {
				clear()
				reject(err.response.data?.log_content?.error_code || err)
			})
	})
}

export const loadUser = () => (dispatch) => {
	return new Promise((resolve, reject) => {
		getUser()
			.then(async (res) => {
				await dispatch({
					type: LOGIN_SUCCESS,
					payload: {
						...res.data.content.user,
						social_thumb: getSocialThumbByBrowser(res?.data?.content?.user)
					}
				})
				setProfile({
					...res.data.content.user,
					social_thumb: getSocialThumbByBrowser(res?.data?.content?.user)
				})
				resolve()
			})
			.catch((error) => {
				reject(error.response?.data.detail)
				clear()
			})
	})
}

export const logoutUser = () => (dispatch) => {
	return new Promise(async (resolve, reject) => {
		await logout()
		localStorage.removeItem('@vittude:match-maker')
		dispatch({ type: CLEAR_SCHEDULE })
		dispatch({ type: LOGOUT })
		resolve()
	})
}

export const updateProfilePhoto = (dataUrl, name) => (dispatch) => {
	return new Promise((resolve, reject) => {
		updatePhoto(dataUrl, name)
			.then((res) => {
				dispatch({ type: UPDATE_PROFILE_PHOTO, payload: res?.data?.content })
				resolve(res?.data?.content)
			})
			.catch((error) => reject(error))
	})
}

export const setPartnershipsList = (value) => {
	return {
		type: UPDATE_PARTNERSHIPS_LIST,
		payload: value
	}
}
